// extracted by mini-css-extract-plugin
export var btnBlock = "style-module--btn-block--85f4d";